var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.animate)?_c('overdrive',{key:"a",attrs:{"id":"el"}},[_c('div',{staticClass:"circle w-24 h-24 bg-pink"})]):_vm._e(),_vm._v(" "),(_vm.animate)?_c('overdrive',{key:"b",attrs:{"id":"el"}},[_c('div',{staticClass:"rect w-24 h-24 bg-blue"})]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4da8f78c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sandbox.vue
// module id = null
// module chunks = 